import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import ProductOption from "./product-option.js";
import Stack from "./stack.js";
export default function ProductOptions(props) {
  const {
    articles,
    quantity,
    selectedOptionIds,
    optionsPrices = {},
    onChange,
    ...rest
  } = props;
  const selected = new Set(selectedOptionIds);
  const toggle = (id) => {
    if (!onChange)
      return;
    if (selected.has(id)) {
      selected.delete(id);
    } else {
      selected.add(id);
    }
    onChange([...selected]);
  };
  return /* @__PURE__ */ React.createElement(Container, {
    ...rest
  }, articles.map((article) => /* @__PURE__ */ React.createElement(ProductOption, {
    key: article.id,
    article,
    option: article.option,
    quantity,
    onClick: () => toggle(article.id),
    selected: selectedOptionIds.includes(article.id),
    prices: optionsPrices[article.id]
  })));
}
const Container = styled(Stack)`
  margin-top: 10px;

  > div {
    cursor: pointer;
  }
`;
